(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracUnusedDialogController', NasracUnusedDialogController);

    NasracUnusedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracService', 'NasracSource', 'NasracProvider'];

    function NasracUnusedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracService, NasracSource, NasracProvider) {
        var vm = this;
        vm.close = close;
        vm.nasracService = entity;

        function close () {
            $uibModalInstance.dismiss('close');
        }

        function getMissingBRSIds () {

            NasracService.query(vm.nasracService, onGetMissingBRSIdsSuccess, onGetMissingBRSIdsError);

        }

        function onGetMissingBRSIdsSuccess (result) {

            vm.unusedBsgList =findMissingNumbers(result);// result;
        }

        function onGetMissingBRSIdsError () {

        }
        function findMissingNumbers(result) {

            var a = [];
            // var missingList = [];
            var missingRangeList = [];
            for(var i=0;i<result.length;i++){
                a.push(result[i].id);
            }
            a = a.sort(function (e1, e2) {  return e1 - e2;  });



            var numberExists = true;
            var missingRange = "";
            var j = a[0];
            for (var i=0;i<a.length;i++)
            {
                if(a.length-1 !== i && a[i]+1 !== a[i+1]){
                    missingRange = a[i]+1 +""+ (a[i]+2 == a[i+1] ? "" : " - "+(a[i+1]-1).toString() );
                    missingRangeList.push(missingRange);
                } else
                {
                    continue;
                }

                /*
                if (j==a[i])
                {
                    if(!numberExists){
                        numberExists = !numberExists;
                        missingRange = missingRange +""+ (missingRange == j-1 ? "" : " - "+(j-1).toString() );
                        missingRangeList.push(missingRange);
                        missingRange = "";
                    }
                    numberExists = true;
                    j++;
                    continue;
                }
                else
                {
                    if(numberExists){
                        numberExists = !numberExists;
                        missingRange = j;
                    }
                    numberExists = false;
                    // missingList.push(j);
                    i--;
                    j++;
                }*/
            }
            return missingRangeList;

        }
        getMissingBRSIds();
    }
})();
